export enum ContractType {
  DISTANCE_SELLING_CONTRACT_DOMESTIC = 'DistanceSellingContractDomestic',
  DISTANCE_SELLING_CONTRACT_ABROAD = 'DistanceSellingContractAbroad',
  PRELIMINARY_INFORMATION_FORM_DOMESTIC = 'PreliminaryInformationFormDomestic',
  PRELIMINARY_INFORMATION_FORM_ABROAD = 'PreliminaryInformationFormAbroad',
  PACKAGE_TOUR_CONTRACT_DOMESTIC = 'PackageTourContractDomestic',
  PACKAGE_TOUR_CONTRACT_ABROAD = 'PackageTourContractAbroad',
  PACKAGE_TOUR_BROCHURE = 'PackageTourBrochure',
  PACKAGE_TOUR_CONTRACT = 'PackageTourContract',
  FLIGHT_TICKET_CONTRACT = 'FlightTicketContract',
  VEHICLE_RENTAL_CONDITIONS = 'VehicleRentalConditions',
  EXPEDIA_EPS = 'ExpediaEps',
}
